export const menus = [
  // {
  //   label: 'Dashboard',
  //   value: 'dashboard',
  //   route: '/dashboard',
  //   icon: 'pie-chart',

  // },
  {
    label: 'Content',
    value: 'content',
    route: '/content',
    icon: 'file-text',
    submenus: [{ label: 'Page', value: 'page', route: 'page' }],
  },
  {
    label: 'Province',
    value: 'province',
    route: '/province',
    icon: 'file-text',
  },
  {
    label: 'Category',
    value: 'category',
    route: '/category',
    icon: 'appstore-o',
  },
  {
    label: 'Class',
    value: 'class',
    route: '/class',
    icon: 'book',
    // submenus: [
    //   { label: 'Class', value: 'class', route: 'class' },
    // ],
  },
  {
    label: 'Schedule',
    value: 'schedule',
    route: '/schedule',
    icon: 'schedule',
  },
  {
    label: 'Revenue Summary',
    value: 'revenueSummary',
    route: '/revenue-summary',
    icon: 'pay-circle',
  },
  {
    label: 'Withdraw',
    value: 'withdraw',
    route: '/withdraw',
    icon: 'pay-circle',
  },
  {
    label: 'Order',
    value: 'order',
    route: '/order',
    icon: 'shopping-cart',
  },

  { label: 'Student', value: 'student', route: '/student', icon: 'user' },
  {
    label: 'Teacher',
    value: 'teacher',
    icon: 'user',
    route: '/teacher',
  },
  { label: 'Promocode', value: 'promocode', route: '/promocode', icon: 'user' },
  { label: 'Point', value: 'point', route: '/point', icon: 'transaction' },

  { label: 'Admin', value: 'admin', route: '/admin', icon: 'user' },
  { label: 'PV', value: 'PV', route: '/pv', icon: 'user' },
  { label: 'RV', value: 'RV', route: '/rv', icon: 'user' },

  {
    label: 'Log Off',
    value: 'logoff',
    route: '/logoff',
    icon: '',
  },
];
